<template>
  <transition name="Exit">
    <div class="bl_modalBlock">
      <div class="bl_modalContent">

        <div class="bl_modalTxtBlock">
          <!-- eslint-disable-next-line -->
          <p>はじめの<ruby>画面<rp>(</rp><rt>がめん</rt><rp>)</rp></ruby>に<br class="spBlock">もどりますか？<br><ruby>遊<rp>(</rp><rt>あそ</rt><rp>)</rp></ruby>んだきろくは<br class="spBlock">ほぞんされます</p>
        </div>

        <div class="bl_btnBlock">
          <a class="el_btn" @click="exit()">はい</a>
          <a class="el_btn" @click="close()">いいえ</a>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Exit',
  methods: {
    exit() {
      this.$store.commit('currentPage/changeCurrentPage', 'start');
      this.close();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.bl_modalBlock {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  transition: opacity 2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bl_modalContent {
  width: 60%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 10px;
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.bl_modalTxtBlock{
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 15px;
}

.bl_btnBlock{
  display: flex;
  justify-content: center;
  align-items: center;

  .el_btn{
    margin-right: 10px;
    max-width: 325px;

    &:last-of-type{
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 768px){
  .bl_modalTxtBlock{
    font-size: 22px;
  }

  .bl_btnBlock{
    flex-direction: column;

    .el_btn{
      margin-right: 0;
      margin-bottom: 10px;

      &:last-of-type{
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Exit.vue